var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 6.5,
    fill: "#3B3B3B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20768 4.95866H7.79102V7.79199H4.95768V9.20866H7.79102V12.042H9.20768V9.20866H12.041V7.79199H9.20768V4.95866ZM8.49935 1.41699C4.58935 1.41699 1.41602 4.59033 1.41602 8.50033C1.41602 12.4103 4.58935 15.5837 8.49935 15.5837C12.4093 15.5837 15.5827 12.4103 15.5827 8.50033C15.5827 4.59033 12.4093 1.41699 8.49935 1.41699ZM8.49935 14.167C5.3756 14.167 2.83268 11.6241 2.83268 8.50033C2.83268 5.37658 5.3756 2.83366 8.49935 2.83366C11.6231 2.83366 14.166 5.37658 14.166 8.50033C14.166 11.6241 11.6231 14.167 8.49935 14.167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPost);
export default __webpack_public_path__ + "static/media/add-post.60846c4eabcaa6093eeabd659298f60c.svg";
export { ForwardRef as ReactComponent };